import * as swcHelpers from '@swc/helpers';
import React__default, { useMemo } from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Button from '../Button/Button.js';
import { useIsPhone } from '../MediaQuery/MediaQueryContext.js';

const ModalFooter = ({ ctaCaption , onCancel , onCta , ctaButtonType , cancelCaption , associatedFormId , ctaLoading =false , className ,  })=>{
    const isPhone = useIsPhone();
    const { getLabel  } = useIntl();
    const cancelProps = useMemo(()=>({
            'data-t': 'modal-footer-cancel-button',
            className: 'modal-footer__button',
            caption: cancelCaption !== null && cancelCaption !== void 0 ? cancelCaption : getLabel('common.actions.cancel'),
            'aria-label': cancelCaption !== null && cancelCaption !== void 0 ? cancelCaption : getLabel('common.actions.cancel'),
            variant: 'outline',
            onClick: onCancel
        })
    , [
        cancelCaption,
        getLabel,
        onCancel
    ]);
    const ctaProps = useMemo(()=>({
            'data-t': 'modal-footer-cta-button',
            className: 'modal-footer__button',
            caption: ctaCaption,
            'aria-label': ctaCaption,
            variant: 'solid',
            onClick: onCta,
            type: ctaButtonType,
            form: associatedFormId,
            isLoading: ctaLoading
        })
    , [
        associatedFormId,
        ctaButtonType,
        ctaCaption,
        ctaLoading,
        onCta
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('modal-footer', className)
    }, isPhone ? /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Button, swcHelpers.extends({}, ctaProps)), /*#__PURE__*/ React__default.createElement(Button, swcHelpers.extends({}, cancelProps))) : /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Button, swcHelpers.extends({}, cancelProps)), /*#__PURE__*/ React__default.createElement(Button, swcHelpers.extends({}, ctaProps))));
};
var ModalFooter$1 = ModalFooter;

export { ModalFooter$1 as default };
//# sourceMappingURL=ModalFooter.js.map
